<template>
    <div class="export-lsp-content">
        <span 
            class="export-lsp-content__button icon-download" 
            @click="openExportLSPModal" 
            icon="file-export"
            v-tooltip="{ content: $t('ExportLspCourse.export_course'), html: true }"
        >
        </span>
        <ModalExportLSPContent :course="course" />
    </div>
</template>

<script>
    import ModalExportLSPContent from 'components/shared/modals/ModalExportLSPContent'
    import { mapGetters } from 'vuex'
    export default {
        name: 'export-lsp-content',
        components: {
            ModalExportLSPContent
        },
        props: {
            course: Object
        },
        data () {
            return {
                type: 'info'
            }
        },
        computed: {
            ...mapGetters({
                lspExportErrors: 'Courses/getLspExportErrors'
            })
        },
        methods: {
            openExportLSPModal () {
                this.$modal.show('export-lsp-content')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .export-lsp-content {
        display: flex;
        align-items: center;

        &__button {
            white-space: nowrap;
            color: $lavender;
            font-size: 2.4rem;
        }

        &__toast-message {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
        }
    }
</style>
